import { currencyFormat, numberFormat } from '@tokenyico/design-system';

export const displayCurrency = (amount, currency, withDecimals = true) => {
  if (
    ![
      'ADA',
      'BCH',
      'BNB',
      'BSV',
      'BTC',
      'XBT',
      'DASH',
      'DOGE',
      'EOS',
      'ETH',
      'LTC',
      'VTC',
      'XLM',
      'XMR',
      'XNO',
      'XRP',
      'XTZ',
      'ZEC',
    ].includes(currency)
  ) {
    // crypto coin list taking from https://en.wikipedia.org/wiki/ISO_4217#Unofficial_codes_for_cryptocurrencies
    // force display with custom code

    // fiat currency handled by i18n function
    try {
      return currencyFormat(amount, currency, !!withDecimals);
    } catch (e) {
      // i18n will throw if currency is unknown
    }
  }
  // tokens handled by custom code
  let decimals = 0;
  if (typeof withDecimals === 'number') {
    decimals = withDecimals;
  } else if (withDecimals) {
    decimals = 18;
  }

  const isCurrencySymbolFirst = currencyFormat(1, 'EUR', false).startsWith('€');
  if (isCurrencySymbolFirst) {
    return currency + ' ' + numberFormat(amount, decimals);
  } else {
    return numberFormat(amount, decimals) + ' ' + currency;
  }
};

export const formatExchangeRate = (rate, fromCurrency, toCurrency) => {
  const toCurrencyFormat = displayCurrency(rate, toCurrency, true);
  return displayCurrency(1, fromCurrency, false) + ' = ' + toCurrencyFormat;
};
